import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import noScroll from 'no-scroll'
import Icon from 'components/Icon'

import { MobileScreen, DesktopScreen } from 'utils/screen'
import ProfileModal from './ProfileModal'
import ProfileMenu from './ProfileMenu'
import {
  ProfileContainer,
  Avatar,
  UserNameContainer,
  AvatarContainer,
} from './styled'
import { connect } from 'react-redux'
import {
  selectIsLoaded,
  fetchProfile,
  selectIsLoading,
} from 'auth/modules/profile'
import { selectIsAuthenticated } from 'auth/modules/auth'
import asset from 'utils/asset'

class Profile extends React.Component {
  state = {
    isOpen: false,
  }

  componentDidMount = () => {
    if (this.props.shouldFetchProfile) this.props.fetchProfile()
  }

  componentWillUnmount() {
    noScroll.off()
  }

  toggleOpen = () => {
    if (this.state.isOpen) {
      noScroll.off()
    } else {
      noScroll.on()
    }
    const isOpen = !this.state.isOpen
    this.props.openProfile(isOpen)
    this.setState({
      isOpen,
    })
  }

  logout = () => {
    this.toggleOpen()
    this.props.logout()
  }

  render() {
    const { image, firstname, lastname, isMultiVendor } = this.props
    const { isOpen } = this.state
    const icon = isOpen ? 'up' : 'down'

    return (
      <Fragment>
        <MobileScreen>
          <ProfileContainer
            pointer
            onClick={this.toggleOpen}
            className={isMultiVendor && 'multivendor'}
          >
            {isMultiVendor ? (
              <Fragment>
                <AvatarContainer>
                  <Avatar
                    avatar={image || asset('images/guest-avatar.jpeg')}
                    color="black"
                    className="multivendor"
                  />
                </AvatarContainer>
                <UserNameContainer>{firstname}</UserNameContainer>
              </Fragment>
            ) : (
              <Fragment>
                <Avatar avatar={image} />
                <Icon name={`fas fa-chevron-${icon}`} size={10} />
              </Fragment>
            )}
          </ProfileContainer>
          <ProfileModal
            isOpen={isOpen}
            toggleOpen={this.toggleOpen}
            logout={this.logout}
            image={
              isMultiVendor ? image || asset('images/guest-avatar.jpeg') : image
            }
            firstname={firstname}
            lastname={lastname}
            color={isMultiVendor && 'black'}
            isMultiVendor={isMultiVendor}
          />
        </MobileScreen>
        <DesktopScreen>
          <ProfileContainer className={isMultiVendor && 'multivendor'}>
            {isMultiVendor ? (
              <Fragment>
                <AvatarContainer>
                  <Avatar
                    avatar={image || asset('images/guest-avatar.jpeg')}
                    color="black"
                    className="multivendor"
                  />
                </AvatarContainer>
                {firstname && <UserNameContainer>{firstname}</UserNameContainer>}
              </Fragment>
            ) : (
              <Fragment>
                <Avatar avatar={image} />
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.48226 4.06367C1.80177 3.94193 2.09628 3.99458 2.34075 4.22324C2.79894 4.65174 3.24826 5.08893 3.70117 5.52261C4.4378 6.22788 5.17532 6.93235 5.90928 7.64021C5.97628 7.7048 6.00893 7.70051 6.07377 7.63843C7.02705 6.72591 7.98337 5.8163 8.93875 4.90585C9.16567 4.68962 9.39467 4.47525 9.61795 4.25557C9.94329 3.9355 10.4354 3.91765 10.7626 4.21879C11.0844 4.51495 11.0789 4.99508 10.747 5.31209C9.48602 6.51619 8.22424 7.71945 6.96276 8.92299C6.85308 9.02768 6.7443 9.13323 6.6334 9.23671C6.25861 9.58629 5.71701 9.58965 5.34607 9.23546C3.97791 7.92904 2.61267 6.61992 1.24663 5.31148C1.0854 5.15705 0.993697 4.97359 1.00034 4.75117C1.00228 4.44704 1.18805 4.17577 1.48226 4.06367Z" fill="black"/>
                </svg>
              </Fragment>
            )}
            <ProfileMenu
              avatar={
                isMultiVendor
                  ? image || asset('images/guest-avatar.jpeg')
                  : image
              }
              color={isMultiVendor && 'black'}
              isMultiVendor={isMultiVendor}
            />
          </ProfileContainer>
        </DesktopScreen>
      </Fragment>
    )
  }
}

Profile.propTypes = {
  logout: PropTypes.func.isRequired,
  openProfile: PropTypes.func,
  image: PropTypes.string,
  firstname: PropTypes.string,
  lastname: PropTypes.string,
}

const withState = connect(
  state => ({
    shouldFetchProfile:
      selectIsAuthenticated(state) &&
      !selectIsLoaded(state) &&
      !selectIsLoading(state),
  }),
  { fetchProfile },
)

export default withState(Profile)
